interface IGetEtazhiBlackFridayUriParams {
  queryString?: string;
  jsonQueryString?: string;
}

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-250843
 */
export const getEtazhiBlackFridayUri = (params: IGetEtazhiBlackFridayUriParams) => {
  const { queryString = '', jsonQueryString = '' } = params;
  const urlSearchParams = new URLSearchParams(queryString + jsonQueryString);

  const newQuery = urlSearchParams.toString();

  return '/cat.php?' + newQuery;
};
